.aq{justify-content:center;}